<script>
export default {
    name: 'IconBug',
    props: {

    },
    data() {
        return {

        }
    },
    computed: {

    },
    methods: {

    }
}
</script>
<template>
  <icon-base>
    <path d="M10 7H2v6h8v5l8-8-8-8v5z" />
  </icon-base>
</template>
